import { jsx as C } from "react/jsx-runtime";
import { Theme as a, TextAlignType as r, TextOnly as z } from "@nextgen-web-framework/all";
import './assets/TextOnly.css';const V = "#ffffff", f = "#396e75", u = "#e5fdff", k = "#546223", h = "#f0fae5", m = "#a65523", p = "#fff1e8", R = "#7f3e3e", B = "#ffe2e2", b = "#62625a", T = "#f8f8e7", G = "#38539a", O = "#707070", y = "#c8f8d1", E = "#87c9c8", A = "#5291b1", w = "rgba(82, 145, 177, 0.1019607843)", W = "#445685", _ = "#181d61", x = "rgba(24, 29, 97, 0.1019607843)", P = "#5969d6", v = "#ea999d", N = "#b6577e", Y = "rgba(182, 87, 126, 0.1019607843)", L = "#7e3e80", q = "#1e247f", M = "rgba(30, 36, 127, 0.1019607843)", S = "#da7600", U = "#107f47", j = "#d91734", D = "12", F = "_html_zqezf_38", H = {
  amwayWhite: V,
  darkBlue: f,
  lightBlue: u,
  darkGreen: k,
  lightGreen: h,
  darkOrange: m,
  lightOrange: p,
  darkRed: R,
  lightRed: B,
  darkYellow: b,
  lightYellow: T,
  darkPurple: G,
  darkGrayOnWhite: O,
  dataVizColor1: y,
  dataVizColor2: E,
  dataVizColor3: A,
  dataVizColor3Background: w,
  dataVizColor4: W,
  dataVizColor5: _,
  dataVizColor5Background: x,
  dataVizColor6: P,
  dataVizColor7: v,
  dataVizColor8: N,
  dataVizColor8Background: Y,
  dataVizColor9: L,
  dataVizColor10: q,
  dataVizColor10Background: M,
  dataVizAlertOrange: S,
  dataVizSuccessGreen: U,
  dataVizWarningRed: j,
  roundedContainerRadius: D,
  "no-visible": "_no-visible_zqezf_34",
  html: F
}, I = {
  blue: a.BLUE,
  orange: a.ORANGE,
  green: a.GREEN,
  red: a.RED,
  purple: a.PURPLE
}, J = {
  left: r.LEFT,
  center: r.CENTER,
  right: r.RIGHT
}, X = (e) => {
  const { titleConfig: t, descriptionConfig: n, theme: d, bgColor: i, rounded: l } = e, s = (o) => o ? J[o] : null, c = (o) => o ? I[o] : null, g = {
    className: "",
    titleConfig: {
      ...t,
      formatType: t.formatType,
      alignment: s(t.alignment) ?? void 0
    },
    descriptionConfig: {
      ...n
    },
    theme: c(d) ?? void 0,
    backgroundColor: i,
    borderRadius: l ? H.roundedContainerRadius : "0"
  };
  return /* @__PURE__ */ C(z, { ...g });
};
export {
  J as A,
  X as T,
  H as s,
  I as t
};
//# sourceMappingURL=TextOnly-1d491347.mjs.map
